/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  settings: 'Réglages',
  setting: 'Réglage',
  defaultLocale: 'Paramètres régionaux par défaut',
  mail: 'E-mail',
  driver: 'Driver',
  host: 'Hôte',
  port: 'Port',
  username: 'Nom d\'utilisateur',
  password: 'Mot de passe',
  encryption: 'Chiffrement',
  fromAddress: 'De l\'adresse',
  fromName: 'Du Nom',
  save: 'Sauver',
  saveSuccess: 'Paramètres enregistrés avec succès.',
  saveFailure: 'Les paramètres n\'ont pas pu être enregistrés.',
  fetchFailure: 'Les paramètres n\'ont pas pu être récupérés.',
  updates: 'Mises à jour',
  update: 'Mettre à jour',
  newUpdatesAvailable: 'De nouvelles mises à jour sont disponibles en téléchargement.',
  beforeUpdatingMakeSure: 'Avant la mise à jour, assurez-vous que le répertoire d\'installation de Plainpad est accessible en écriture par le processus PHP. Dans le cas où la mise à jour se termine par une erreur, vous devrez peut-être exécuter manuellement la commande "php artisan refresh" depuis le terminal afin de finaliser le processus.',
}
